<template>
  <span>
    <span v-if="item.style" :style="item.style">
      <i class="fas fa-circle"></i>
    </span>
    <span>
      {{ item.text }}
    </span>
  </span>
</template>

<script>
export default {
  beforeMount() {
    this.item = this.params.context.getRetailerText(this.params);
  },

  methods: {
    isRetailer() {
      return !isNaN(this.params.node.key) && !isNaN(parseInt(this.params.node.key));
    },
  }
}
</script>
